import Vue from 'vue'
import App from '@/App.vue'
import router from '@/router'
import store from "@/store"

require("@/assets/scss/Index.scss");
import "@js/directives";
import "@js/filters";

Vue.config.ignoredElements = ['wx-open-launch-weapp'];
Vue.config.productionTip = false;

import Components from "@/components"
Vue.use(Components)

//api
import * as api from '@/api';
Vue.prototype.$api = api;
//导航
import navigation from "@js/navigation"
sessionStorage.setItem("pagelength","1");
Vue.prototype.$navigation = navigation;
//提示
import Toast from "@/components/toast"
import Prompt from "@/components/prompt"
Vue.prototype.$Toast = Toast;
Vue.prototype.$Prompt = Prompt;

//app交互
import appInteraction from '@/common/appInteraction.js';
window.yd = appInteraction || {};

window.yd.jumpWxMallGoods = function(goodsId) {
  if (goodsId) {
    appInteraction.jumpWxMiniApp("/pages/shoppingMall/goodDetail/goodDetail?id="+goodsId);
  }
}

if(process.env.NODE_ENV == "production"){
  appInteraction.ready(function(){
    //获取app原生信息和加密key
    appInteraction.getAppInfo().then(()=>{
      var vm = new Vue({
        router,
        store,
        render: h => h(App)
      }).$mount('#app')
      window.$vm = vm;
    })
  })
}else{
  store.commit('setAppInfo', {
  ClientId:"169A2359-EE00-4F61-B13D-34B9F3D1632D",
  RequestNowVersion:"12_22021712_10101",
  RequestDigestKey:"BCynzOu8mvNaYT0nbzeq4DEqjM0Ygsah", 
  RequestEncryptKey:"gziuEeiEzU9pWPBBHNTmgR8Q", 
  ResponseDigestKey:"volG+Oj5ygL9X3eGxOKVOqVYN92ApcEy",
  ResponseEncryptKey:"4u3a9ocrrRBDpEZfVHq4QAvB"});
  var vm = new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount('#app');
  window.$vm = vm;
}




